import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from "redux-devtools-extension";
import { taskMiddleware } from "react-palm/tasks";
import { rootReducer } from './reducers/rootReducer';
export var store = createStore(rootReducer, composeWithDevTools(applyMiddleware(taskMiddleware)));
